import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { initialState, DecisionDocumentsState } from './decision-documents.state';
import * as actions from './decision-documents.actions';

const reducer: ActionReducer<DecisionDocumentsState, Action> = createReducer(
  initialState,
  on(
    actions.loadDecisionDocuments,
    (state): DecisionDocumentsState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    actions.loadDecisionDocumentsSuccess,
    (state, { documents }): DecisionDocumentsState => ({
      ...state,
      documents,
      loading: false,
    })
  ),
  on(
    actions.loadDecisionDocumentsError,
    (state): DecisionDocumentsState => ({
      ...state,
      documents: [],
      loading: false,
    })
  ),
  on(
    actions.removeDecisionDocument,
    (state, { userAsset }): DecisionDocumentsState => ({
      ...state,
      removingIds: [...state.removingIds, userAsset.id],
    })
  ),
  on(
    actions.removeDecisionDocumentSuccess,
    (state, { userAssetId }): DecisionDocumentsState => ({
      ...state,
      removingIds: state.removingIds.filter(id => id !== userAssetId),
    })
  ),
  on(
    actions.removeDecisionDocumentError,
    (state, { userAssetId }): DecisionDocumentsState => ({
      ...state,
      removingIds: state.removingIds.filter(id => id !== userAssetId),
    })
  )
);

export function decisionDocumentsReducer(state: DecisionDocumentsState, action: Action): DecisionDocumentsState {
  return reducer(state, action);
}
